import { FormSectionLayout } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { AddOrModifyOptionsFormInput } from "./addOrModifyOptionsWorkflow";

type SelectOptionsStepProps = { formState: ObjectState<AddOrModifyOptionsFormInput> };

export function SelectOptionsStep(_props: SelectOptionsStepProps) {
  return (
    <FormSectionLayout
      title="Select Options"
      description="Add, remove, or change options on this project's current configuration."
      sections={[]}
    />
  );
}
